/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line

import { Button, message } from 'antd'

import { agentAction } from '../../../action/agent'
import SimplePopover from '../../../components/SimplePopover'
import { instanceStore } from '../../../store/list/InstanceModel'

import * as GeneralUtils from '../../../utils/general'

const ACTION_CONDITION: any = {
  resume: [{ status: 10, vm_status: 20 }],
  pause: [{ status: 10, vm_status: 10 }],
}
const isActionDisabled = (record: any, type: string) => {
  return GeneralUtils.isActionDisabled(record, type, ACTION_CONDITION)
}

export default (props: { text: any, record: any }) => {
  const onResumeMachineInstance = (instanceId: string) => {
    agentAction.resumeAgentInstance(instanceId)
      .then(responseData => {
        message.info('实例启动成功')
        instanceStore.reloadCurrentPage()
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  const onPauseMachineInstance = (instanceId: string) => {
    agentAction.pauseAgentInstance(instanceId)
      .then(responseData => {
        message.info('实例暂停成功')
        instanceStore.reloadCurrentPage()
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  return <span>
    <SimplePopover title="实例管理" text="实例管理">
      <Button
        onClick={() => { onResumeMachineInstance(props.record['instance_id']) }}
        disabled={isActionDisabled(props.record, 'resume')}
        type="primary" size="small" block
      >启动</Button>
      <Button
        onClick={() => { onPauseMachineInstance(props.record['instance_id']) }}
        disabled={isActionDisabled(props.record, 'pause')}
        size="small" type="danger" block
      >暂停</Button>
    </SimplePopover>
  </span>
}
